import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { Text16, Title2 } from '@sorare/core/src/atoms/typography';
import Dialog from '@sorare/core/src/components/dialog';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import { useOneTimeDialogContext } from '@sorare/core/src/contexts/oneTimeDialog';
import { OneTimeDialog } from '@sorare/core/src/contexts/oneTimeDialog/Provider';
import { LIFECYCLE } from '@sorare/core/src/hooks/useLifecycle';
import { glossary } from '@sorare/core/src/lib/glossary';

const Wrapper = styled(Vertical).attrs({ gap: 3, center: true })`
  padding: var(--triple-unit) var(--double-unit);
  justify-content: stretch;
`;

const Img = styled.img`
  max-width: 100%;
  max-height: auto;
`;

const MessageBox = styled.div`
  display: inherit;
  flex-direction: inherit;
  text-align: center;
  gap: var(--unit);
  padding: 0 var(--unit);
`;

type Props = {
  img: string;
};
export const NewUserDialog = ({ img }: Props) => {
  const { sawDialog } = useOneTimeDialogContext();
  const { currentUser } = useCurrentUserContext();

  if (!currentUser) return null;

  return (
    <OneTimeDialog
      dialogId={LIFECYCLE.sawUsSportsCollectionsDialog}
      show={!sawDialog(LIFECYCLE.sawUsSportsCollectionsDialog)}
    >
      {({ onClose, open }) => (
        <Dialog open={open} maxWidth="xs" fullScreen={false} onClose={onClose}>
          <Wrapper>
            <Img src={img} alt="" />
            <MessageBox>
              <Title2>
                <FormattedMessage
                  id="Collections.NewUserDialog.Title"
                  defaultMessage="Build Your Dynasty"
                />
              </Title2>
              <Text16>
                <FormattedMessage
                  id="Collections.NewUserDialog.Description"
                  defaultMessage="Collect cards of Limited scarcity or higher to complete collections."
                />
              </Text16>
            </MessageBox>
            <Button size="medium" color="primary" onClick={onClose}>
              <FormattedMessage {...glossary.gotIt} />
            </Button>
          </Wrapper>
        </Dialog>
      )}
    </OneTimeDialog>
  );
};
